import React, { useState, useEffect } from 'react';
import { newsAPI } from '../../services/api';

const NewsSection = () => {
    const [news, setNews] = useState([]);
    const [formData, setFormData] = useState({});
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {
        try {
            setLoading(true);
            const res = await newsAPI.getAll();
            setNews(res.data || []);
        } catch (error) {
            console.error('Erreur chargement:', error);
            setNews([]);
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const data = new FormData();
            data.append('title', formData.title || '');
            data.append('title_ar', formData.title_ar || '');
            data.append('content', formData.content || '');
            data.append('content_ar', formData.content_ar || '');
            if (formData.image) data.append('image', formData.image);
            else if (formData.image_url) data.append('image_url', formData.image_url);

            if (formData.id) {
                await newsAPI.update(formData.id, data);
            } else {
                await newsAPI.create(data);
            }
            loadData();
            setFormData({});
            alert('✅ Actualité enregistrée!');
        } catch (error) {
            alert('❌ Erreur lors de l\'enregistrement');
            console.error(error);
        }
    };

    const handleDelete = async (id) => {
        if (window.confirm('Supprimer cette actualité?')) {
            try {
                await newsAPI.delete(id);
                loadData();
            } catch (error) {
                alert('Erreur lors de la suppression');
            }
        }
    };

    if (loading) {
        return (
            <div style={styles.loadingContainer}>
                <div style={styles.spinner}></div>
                <p>Chargement...</p>
            </div>
        );
    }

    return (
        <div>
            <h1 style={styles.title}>📰 Actualités de la Ligue</h1>

            <div style={styles.card}>
                <h2 style={styles.cardTitle}>
                    {formData.id ? 'Modifier' : 'Ajouter'} une actualité
                </h2>
                <form onSubmit={handleSubmit} style={styles.form}>
                    <div style={styles.row}>
                        <div style={styles.col}>
                            <label style={styles.label}>Titre (FR)</label>
                            <input
                                type="text"
                                value={formData.title || ''}
                                onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                                style={styles.input}
                                placeholder="Titre en français"
                                required
                            />
                        </div>
                        <div style={styles.col}>
                            <label style={styles.label}>العنوان (AR)</label>
                            <input
                                type="text"
                                value={formData.title_ar || ''}
                                onChange={(e) => setFormData({ ...formData, title_ar: e.target.value })}
                                style={{ ...styles.input, direction: 'rtl' }}
                                placeholder="العنوان بالعربية"
                            />
                        </div>
                    </div>

                    <div style={styles.row}>
                        <div style={styles.col}>
                            <label style={styles.label}>Contenu (FR)</label>
                            <textarea
                                value={formData.content || ''}
                                onChange={(e) => setFormData({ ...formData, content: e.target.value })}
                                style={{ ...styles.input, minHeight: '120px' }}
                                placeholder="Contenu en français"
                            />
                        </div>
                        <div style={styles.col}>
                            <label style={styles.label}>المحتوى (AR)</label>
                            <textarea
                                value={formData.content_ar || ''}
                                onChange={(e) => setFormData({ ...formData, content_ar: e.target.value })}
                                style={{ ...styles.input, minHeight: '120px', direction: 'rtl' }}
                                placeholder="المحتوى بالعربية"
                            />
                        </div>
                    </div>

                    <div style={styles.formGroup}>
                        <label style={styles.label}>Image</label>
                        <input
                            type="file"
                            accept="image/*"
                            onChange={(e) => setFormData({ ...formData, image: e.target.files[0] })}
                            style={styles.input}
                        />
                    </div>

                    <div style={styles.formActions}>
                        <button type="submit" style={styles.submitBtn}>
                            {formData.id ? 'Modifier' : 'Publier'}
                        </button>
                        {formData.id && (
                            <button type="button" onClick={() => setFormData({})} style={styles.cancelBtn}>
                                Annuler
                            </button>
                        )}
                    </div>
                </form>
            </div>

            <div style={styles.card}>
                <h2 style={styles.cardTitle}>Liste des actualités ({news.length})</h2>
                {news.length === 0 ? (
                    <div style={styles.emptyState}>
                        <p>Aucune actualité trouvée</p>
                        <p style={styles.emptyHint}>Ajoutez votre première actualité ci-dessus</p>
                    </div>
                ) : (
                    <div style={styles.newsGrid}>
                        {news.map(item => (
                            <div key={item.id} style={styles.newsCard}>
                                {item.image_url && (
                                    <img src={item.image_url} alt={item.title} style={styles.newsImage} />
                                )}
                                <div style={styles.newsContent}>
                                    <h3 style={styles.newsTitle}>{item.title}</h3>
                                    <p style={styles.newsTitleAr}>{item.title_ar}</p>
                                    <p style={styles.newsExcerpt}>{item.content?.substring(0, 100)}...</p>
                                    <div style={styles.newsActions}>
                                        <button onClick={() => setFormData(item)} style={styles.editBtn}>
                                            Modifier
                                        </button>
                                        <button onClick={() => handleDelete(item.id)} style={styles.deleteBtn}>
                                            Supprimer
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

const styles = {
    title: { fontSize: '32px', fontWeight: 'bold', marginBottom: '20px' },
    card: { background: 'white', padding: '30px', borderRadius: '15px', marginBottom: '30px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' },
    cardTitle: { fontSize: '20px', fontWeight: 'bold', marginBottom: '20px' },
    form: { display: 'flex', flexDirection: 'column', gap: '15px' },
    formGroup: { display: 'flex', flexDirection: 'column', gap: '8px' },
    label: { fontSize: '14px', fontWeight: 'bold', color: '#333' },
    input: { padding: '12px', border: '2px solid #e0e0e0', borderRadius: '8px', fontSize: '15px' },
    row: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' },
    col: { display: 'flex', flexDirection: 'column', gap: '8px' },
    formActions: { display: 'flex', gap: '10px' },
    submitBtn: { padding: '15px', background: '#c41e3a', color: 'white', border: 'none', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer', flex: 1 },
    cancelBtn: { padding: '15px', background: '#6c757d', color: 'white', border: 'none', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer' },
    newsGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '20px' },
    newsCard: { background: '#f9f9f9', borderRadius: '12px', overflow: 'hidden', border: '2px solid #e0e0e0' },
    newsImage: { width: '100%', height: '180px', objectFit: 'cover' },
    newsContent: { padding: '20px' },
    newsTitle: { fontSize: '18px', fontWeight: 'bold', marginBottom: '5px' },
    newsTitleAr: { fontSize: '14px', color: '#666', marginBottom: '10px', direction: 'rtl' },
    newsExcerpt: { fontSize: '14px', color: '#777', marginBottom: '15px', lineHeight: '1.5' },
    newsActions: { display: 'flex', gap: '10px' },
    editBtn: { padding: '8px 15px', background: '#007bff', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer', fontSize: '13px', flex: 1 },
    deleteBtn: { padding: '8px 15px', background: '#dc3545', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer', fontSize: '13px', flex: 1 },
    loadingContainer: { display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '60px', color: '#666' },
    spinner: { width: '50px', height: '50px', border: '5px solid #f3f3f3', borderTop: '5px solid #c41e3a', borderRadius: '50%', animation: 'spin 1s linear infinite' },
    emptyState: { textAlign: 'center', padding: '60px 20px', color: '#999' },
    emptyHint: { fontSize: '14px', marginTop: '10px' }
};

// Animation CSS
const styleSheet = document.createElement('style');
styleSheet.textContent = `
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;
if (!document.getElementById('news-section-styles')) {
    styleSheet.id = 'news-section-styles';
    document.head.appendChild(styleSheet);
}

export default NewsSection;
